module.exports = __webpack_public_path__ + "img/2.218cf2e9.png";